export interface CmsRegistrationOrderConfirmationPageHeader {
  registrationOrderConfirmationPageTitle: string;
  registrationOrderConfirmationPageSubtitle: string;
}
